import { jsx as _jsx } from "react/jsx-runtime";
function ArrowDownCircle({ className, size = 24 }) {
    return (_jsx("svg", { className: className, height: size, width: size, fill: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { fillRule: "evenodd", d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10zm-5.474-.525l-1.132-1.132-2.594 2.594V7.2h-1.6v5.737l-2.594-2.594-1.131 1.132L12 16l4.526-4.525z", clipRule: "evenodd" }) }));
}
export default ArrowDownCircle;
